import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Grid,
  Typography
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppApi from '../api/CognitoApi';
import { useMEConfig, useGeneratorConfig } from '../api/GetData';
import './configSidebar.css';

const Api = new AppApi();

export const ConfigPopup = ({
  open,
  onClose,
  set = [
    true, true, true, true, true, true, true, true, true, true,
    true, true, true, true, true, true, true,true
  ],
  setOpen,
  setSeverity = () => {},
  setMessage = () => {},
  plantName,
}) => {
  const isMobile = useMediaQuery('(max-width:720.9px)');
  const { data: MEConfig } = useMEConfig(plantName);

  const {data: GeneratorParams}  = useGeneratorConfig(plantName);

  const [fields, setFields] = useState(
    Array.isArray(GeneratorParams?.Generators)
      ? GeneratorParams.Generators
      : (Array.isArray(GeneratorParams) ? GeneratorParams : [])
  );


  const [minrunhours, setMinRunHours] = useState(0);
  const [maxunprofhours, setMaxUnprofHours] = useState(0);
  const [assetidentifier, setAssetIdentifier] = useState('');
  const [assetname, setAssetName] = useState('');
  const [assettype, setAssetType] = useState('');
  const [actualcapacity, setActualCapacity] = useState(0);
  const [minimumstablegeneration, setMinimumStableGeneration] = useState(0);
  const [marginalcost, setMarginalCost] = useState(0);
  const [offercontrolparty, setOfferControlParty] = useState('');
  const [poweravailability, setPowerAvailability] = useState(0);
  const [optimizedRunLogic, setOptimizedRunLogic] = useState(false);
  const [mcRunLogic, setMcRunLogic] = useState(false);
  const [defaultLogic, setDefaultLogic] = useState(false);
  const [multiBlockMcLogic, setMultiBlockMcLogic] = useState(false);
  const [minProfit, setMinProfit] = useState(0);
  const [unavailableHours, setUnavailableHours] = useState([]);
  const [AOR, setAOR] = useState("");
  const [maxActualCapability, setMaxActualCapability] = useState(0);
  const snapshotRef = useRef(null);

  useEffect(() => {
    if (!plantName) {
      return;
    }
    setMinRunHours(0);
    setMaxUnprofHours(0);
    setAssetIdentifier('');
    setAssetName('loading...');
    setAssetType('');
    setActualCapacity(0);
    setMaxActualCapability(0);
    setMinimumStableGeneration(0);
    setMarginalCost(0);
    setOfferControlParty('');
    setPowerAvailability(0);
    setMinProfit(0);
    setUnavailableHours([]);
    setOptimizedRunLogic(false);
    setMcRunLogic(false);
    setDefaultLogic(false);
    setMultiBlockMcLogic(false);
    setAOR('');
  }, [plantName]);


  useEffect(() => {
    // populate values from MEConfig when available
    if (!MEConfig || typeof MEConfig !== 'object') {
      return;
    }
    setMinRunHours(MEConfig?.min_run_hours ?? 0);
    setMaxUnprofHours(MEConfig?.max_unprof_hours ?? 0);
    setAssetIdentifier(MEConfig?.asset_identifier ?? '');
    setAssetName(MEConfig?.asset_name ?? 'loading...');
    setAssetType(MEConfig?.asset_type ?? 'loading...');
    const maxCap = parseInt(MEConfig?.actual_capacity ?? 0, 10) || 0;
    setActualCapacity(maxCap);
    setMaxActualCapability(maxCap);
    setMinimumStableGeneration(MEConfig?.minimum_stable_generation ?? 0);
    setMarginalCost(MEConfig?.marginal_cost ?? 0);
    setOfferControlParty(MEConfig?.offer_control_party ?? 'loading...');
    setPowerAvailability(MEConfig?.power_availability ?? 0);
    setMinProfit(MEConfig?.min_profit ?? 0);
    setUnavailableHours(MEConfig?.unavailable_hours ?? []);
    setOptimizedRunLogic(MEConfig?.optimizedRunLogic ?? false);
    setMcRunLogic(MEConfig?.mcRunLogic ?? false);
    setDefaultLogic(MEConfig?.defaultLogic ?? false);
    setMultiBlockMcLogic(MEConfig?.multiBlockMcLogic ?? false);
    setAOR(MEConfig?.AOR ?? "");
  }, [MEConfig]);
  const handleGeneratorParamsSubmit = async () => {
    // Normalize generator params to an array
    const genArray = Array.isArray(fields)
      ? [...fields]
      : (Array.isArray(fields?.Generators) ? [...fields.Generators] : []);

    genArray.forEach(field => {
      if (typeof field.value === "string") {
        field.value = field.value === "true"; // Converts "true" to true, any other string to false
      } else if (typeof field.value !== "boolean") {
        field.value = false; // Optionally set a default boolean value if it's neither a string nor a boolean
      }
      // If it's already a boolean, it remains unchanged
    });
    const data3 = { Generators: genArray };
    const parameterName = "GeneratorAvailabilityParam"; 
    const newValue = JSON.stringify(data3); // Convert the fields object to a JSON string
 
    try {
      const response = await Api.updateParameterStoreApi(parameterName, newValue, plantName);
      console.log(response);
      return response;
    } catch (error) {
      console.error("Error updating generator parameter:", error);
      throw error;
    }
   };
  useEffect(() => {
    // populate values from MEConfig when available
    const genArray = Array.isArray(GeneratorParams?.Generators)
      ? GeneratorParams.Generators
      : (Array.isArray(GeneratorParams) ? GeneratorParams : []);
    setFields(genArray);
    console.log("generators",genArray)
  }, [GeneratorParams]);

  // mutually exclusive checkboxes
  useEffect(() => {
    if (optimizedRunLogic) setMcRunLogic(false);
  }, [optimizedRunLogic]);
  useEffect(() => {
    if (mcRunLogic) setOptimizedRunLogic(false);
  }, [mcRunLogic]);
  useEffect(() => {
    if (mcRunLogic) setMultiBlockMcLogic(false);
  }, [mcRunLogic]);
  useEffect(() => {
    if (optimizedRunLogic) setMultiBlockMcLogic(false);
  }, [optimizedRunLogic]);
  useEffect(() => {
    if (multiBlockMcLogic) setOptimizedRunLogic(false);
  }, [multiBlockMcLogic]);
  useEffect(() => {
    if (multiBlockMcLogic) setMcRunLogic(false);
  }, [multiBlockMcLogic]);

  // Restrict numeric inputs to integers only
  const handleIntegerChange = (setter) => (e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/[^0-9]/g, '');
    setter(cleaned === '' ? '' : cleaned);
  };
  const handleCappedIntegerChange = (limit, setter) => (e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/[^0-9]/g, '');
    if (cleaned === '') {
      setter('');
      return;
    }
    const val = parseInt(cleaned, 10);
    setter(Math.min(val, limit).toString());
  };
  const handleIntegerKeyDown = (e) => {
    const blockedKeys = ['.', ',', '-', '+', 'e', 'E'];
    if (blockedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const wrapLabelStyle = {
    whiteSpace: 'normal',
    lineHeight: 1.2,
    display: 'block',
  };
  const generatorFields = Array.isArray(fields)
    ? fields
    : (Array.isArray(fields?.Generators) ? fields.Generators : []);
  const handleGeneratorToggle = (index) => {
    setFields((prev) => {
      const list = Array.isArray(prev)
        ? [...prev]
        : (Array.isArray(prev?.Generators) ? [...prev.Generators] : []);
      if (!list[index]) {
        return prev;
      }
      list[index] = { ...list[index], value: !list[index].value };
      return list;
    });
  };

  // Snapshot current values when dialog opens to support cancel revert
  useEffect(() => {
    if (open) {
      snapshotRef.current = {
        minrunhours,
        maxunprofhours,
        assetidentifier,
        assetname,
        assettype,
        actualcapacity,
        minimumstablegeneration,
        marginalcost,
        offercontrolparty,
        poweravailability,
        optimizedRunLogic,
        mcRunLogic,
        defaultLogic,
        multiBlockMcLogic,
        minProfit,
        unavailableHours,
        AOR,
        fields,
      };
    } else {
      snapshotRef.current = null;
    }
  }, [open]);

  const restoreSnapshot = () => {
    const snap = snapshotRef.current;
    if (!snap) return;
    setMinRunHours(snap.minrunhours);
    setMaxUnprofHours(snap.maxunprofhours);
    setAssetIdentifier(snap.assetidentifier);
    setAssetName(snap.assetname);
    setAssetType(snap.assettype);
    setActualCapacity(snap.actualcapacity);
    setMinimumStableGeneration(snap.minimumstablegeneration);
    setMarginalCost(snap.marginalcost);
    setOfferControlParty(snap.offercontrolparty);
    setPowerAvailability(snap.poweravailability);
    setOptimizedRunLogic(snap.optimizedRunLogic);
    setMcRunLogic(snap.mcRunLogic);
    setDefaultLogic(snap.defaultLogic);
    setMultiBlockMcLogic(snap.multiBlockMcLogic);
    setMinProfit(snap.minProfit);
    setUnavailableHours(snap.unavailableHours);
    setAOR(snap.AOR);
    setFields(snap.fields);
  };

  const handleCancel = () => {
    restoreSnapshot();
    onClose();
  };

  const handleSubmit = async () => {
    let generatorSaved = false;
    let bidBuilderSaved = false;
    const errors = [];

    try {
      await handleGeneratorParamsSubmit();
      generatorSaved = true;
    } catch (error) {
      errors.push('Generator availability save failed.');
    }

    const data = {
      min_run_hours: parseInt(minrunhours || 0),
      max_unprof_hours: parseInt(maxunprofhours || 0),
      asset_identifier: assetidentifier,
      asset_name: assetname,
      asset_type: assettype,
      actual_capacity: parseInt(actualcapacity || 0),
      minimum_stable_generation: parseInt(minimumstablegeneration || 0),
      marginal_cost: parseInt(marginalcost || 0),
      offer_control_party: offercontrolparty,
      power_availability: parseInt(poweravailability || 0),
      min_profit: parseInt(minProfit || 0),
      unavailable_hours: unavailableHours,
      optimizedRunLogic,
      mcRunLogic,
      defaultLogic,
      multiBlockMcLogic,
      AOR
    };

    // update parameter store (bid builder params)
    try {
      const response = await Api.updateParameterStoreApi('bidbuilderparams', JSON.stringify(data), plantName);
      console.log('update bidbuilderparams response:', response);
      bidBuilderSaved = true;
    } catch (error) {
      console.error('Error updating bidbuilderparams:', error);
      errors.push('Bid builder parameters save failed.');
    }

    if (typeof setOpen === "function") {
      setOpen(true);
    }
    if (generatorSaved && bidBuilderSaved) {
      if (typeof setMessage === "function") {
        setMessage("Configuration saved successfully.");
      }
      if (typeof setSeverity === "function") {
        setSeverity("success");
      }
      onClose();
      return;
    }

    if (typeof setMessage === "function") {
      setMessage(errors.join(' ') || "Failed to save configuration.");
    }
    if (typeof setSeverity === "function") {
      setSeverity("error");
    }

    // // update marginal cost parameter (as in your original)
    // try {
    //   const response = await Api.updateParameterStoreApi(
    //     'marginalCostParameter',
    //     JSON.stringify({ 'MC/MW': parseInt(marginalcost || 0) }),
    //     plantName
    //   );
    //   console.log('update marginalCostParameter response:', response);
    //   setSeverity('success');
    //   setMessage(`Good Response ${response?.body ?? ''}`);
    //   setOpen?.(true);
    //   onClose();
    // } catch (error) {
    //   console.error('Error updating marginalCostParameter:', error);
    //   setSeverity('error');
    //   setMessage('Error');
    //   setOpen?.(true);
    // } DONT THINK WE NEED THIS ANYMORE

  
    try {
      const response = await Api.queryInstantaneousRestatement({
        plant: plantName,
        param: "instantaneousRestatement",
        value: 1
      });
      console.log('instantaneous restatement response:', response);
    } catch (error) {
      console.error('Error querying instantaneous restatement:', error);
    }
  };

  return (
    <>
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          backgroundColor: '#0b1422',
          color: '#e7edf7',
          borderRadius: '12px',
          border: '1px solid #22416b',
          boxShadow: '0 16px 36px rgba(10, 22, 42, 0.6)',
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', color: '#e7edf7' }}>
        Configuration Settings
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: '78vh', overflowY: 'auto' }}>
        <Grid container spacing={2}>
          {set[0] && (
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Asset Name"
                variant="outlined"
                value={assetname}
                onChange={(e) => setAssetName(e.target.value)}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}

          {set[1] && (
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Asset Identifier"
                variant="outlined"
                value={assetidentifier}
                onChange={(e) => setAssetIdentifier(e.target.value)}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}

          {set[2] && (
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Offer Control Party"
                variant="outlined"
                value={offercontrolparty}
                onChange={(e) => setOfferControlParty(e.target.value)}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}

          {set[3] && (
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Asset Type"
                variant="outlined"
                value={assettype}
                onChange={(e) => setAssetType(e.target.value)}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}

          {set[4] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Maximum Capability (MW)"
                type="number"
                value={actualcapacity}
                onChange={(e) => setActualCapacity(e.target.value)}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}

          {set[5] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Actual Capability (MW)"
                type="text"
                value={poweravailability}
                onChange={handleCappedIntegerChange(maxActualCapability || 0, setPowerAvailability)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*', max: maxActualCapability }}
              />
            </Grid>
          )}

          {set[6] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Min Stable Generation (MW)"
                type="text"
                value={minimumstablegeneration}
                onChange={handleIntegerChange(setMinimumStableGeneration)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
            </Grid>
          )}

          
          {set[11] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Min Profit"
                type="text"
                value={minProfit}
                onChange={handleCappedIntegerChange((maxActualCapability || 0) * 999, setMinProfit)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
            </Grid>
          )}
          {set[8] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Min Run Hrs"
                type="text"
                value={minrunhours}
                onChange={handleIntegerChange(setMinRunHours)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
            </Grid>
          )}

          {set[9] && (
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Max Unprofitable Hours"
                type="text"
                value={maxunprofhours}
                onChange={handleIntegerChange(setMaxUnprofHours)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
            </Grid>
          )}

          
          
          
          {set[7] && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Marginal Cost (CAD)"
                type="text"
                value={marginalcost}
                onChange={handleCappedIntegerChange(999, setMarginalCost)}
                onKeyDown={handleIntegerKeyDown}
                sx={{ input: { color: '#e7edf7', backgroundColor: '#112036', borderRadius: '6px' }, label: { color: '#e7edf7' } }}
                inputProps={{ step: 1, inputMode: 'numeric', pattern: '[0-9]*' }}
              />
            </Grid>
          )}
          {set[15] && (
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: '#e7edf7' }}>Unavailable Hours</InputLabel>
                <Select
                  multiple
                  value={unavailableHours}
                  onChange={(e) => setUnavailableHours(e.target.value)}
                  renderValue={(selected) => selected.join(', ')}
                  sx={{
                    color: '#e7edf7',
                    backgroundColor: '#112036',
                    borderRadius: '8px',
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: { backgroundColor: '#0f1b2d', color: '#e7edf7', maxHeight: 300 }
                    }
                  }}
                >
                  {[...Array(24).keys()].map((hour) => (
                    <MenuItem key={hour + 1} value={hour + 1}>
                      {hour + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
                
          {/* Checkboxes for logic */}
          {(set[12] || set[13] || set[14] || set[16]) && (
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                {set[12] && (
                  <Box textAlign="center">
                    <Typography variant="body2" sx={{ color: 'white' }}>Optimized Run Logic</Typography>
                    <Checkbox
                      checked={optimizedRunLogic}
                      onChange={(e) => setOptimizedRunLogic(e.target.checked)}
                      sx={{ color: 'white', transform: 'scale(1.3)' }}
                    />
                  </Box>
                )}
                
                {set[13] && (
                  <Box textAlign="center">
                    <Typography variant="body2" sx={{ color: 'white' }}>MC Run Logic</Typography>
                    <Checkbox
                      checked={mcRunLogic}
                      onChange={(e) => setMcRunLogic(e.target.checked)}
                      sx={{ color: 'white', transform: 'scale(1.3)' }}
                    />
                  </Box>
                )}
          
                {set[14] && (
                  <Box textAlign="center">
                    <Typography variant="body2" sx={{ color: 'white' }}>Default Run Logic</Typography>
                    <Checkbox
                      checked={defaultLogic}
                      onChange={(e) => setDefaultLogic(e.target.checked)}
                      sx={{ color: 'white', transform: 'scale(1.3)' }}
                    />
                  </Box>
                )}

                {set[16] && (
                  <Box textAlign="center">
                    <Typography variant="body2" sx={{ color: 'white' }}>Multi Block MC Logic</Typography>
                    <Checkbox
                      checked={multiBlockMcLogic}
                      onChange={(e) => setMultiBlockMcLogic(e.target.checked)}
                      sx={{ color: 'white', transform: 'scale(1.3)' }}
                    />
                  </Box>
                )}
                
          
              </Box>
              
            </Grid>
          )}

        </Grid>
        <Grid container spacing={1}>
          {generatorFields.length > 0 && generatorFields.map((field, index) => (
            <Grid item xs={4} sm={2} key={`${field.name || 'gen'}-${index}`}>
              <Box textAlign="center" sx={{ px: 0.5 }}>
                <Typography variant="body2" sx={{ color: 'white' }}>
                  {field.name}
                </Typography>

                <Checkbox
                  checked={Boolean(field.value)}
                  onChange={() => handleGeneratorToggle(index)}
                  sx={{ color: 'white', transform: 'scale(1.1)' }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
         <Grid container spacing={2}>
        {set[10] && (
            <Grid item xs={32} sm={32}>
                <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                <InputLabel sx={{ color: '#e7edf7' }}>Acceptable Operational Reason</InputLabel>
                <Select
                  value={AOR}
                  label="Acceptable Operational Reason"
                  onChange={(e) => setAOR(e.target.value)}
                    sx={{
                      color: '#e7edf7',
                      backgroundColor: '#112036',
                      borderRadius: '8px',
                      ...(isMobile
                        ? {
                            '.MuiSelect-select': {
                              whiteSpace: 'normal',
                              lineHeight: 1.2,
                              display: 'block',
                            },
                          }
                        : {}),
                    }}
                    renderValue={(selected) =>
                      isMobile ? <span style={wrapLabelStyle}>{selected}</span> : selected
                    }
                    MenuProps={{
                      PaperProps: {
                      sx: {
                        backgroundColor: '#0f1b2d',
                        color: '#e7edf7',
                        ...(isMobile
                          ? {
                              '.MuiMenuItem-root': {
                                whiteSpace: 'normal',
                                lineHeight: 1.2,
                                alignItems: 'flex-start',
                              },
                            }
                          : {}),
                      }
                      }
                    }}
                  >
                    <MenuItem value="Default AC">Default AC</MenuItem>
                    <MenuItem value="*Output Derated due to generating equipment capabilities/weather">
                      *Output Derated due to generating equipment capabilities/weather
                    </MenuItem>
                    <MenuItem value="*Unavailable due to Operational Constraints">
                *Unavailable due to Operational Constraints
              </MenuItem>
              <MenuItem value="Unavailable due to Fortis wires outage">
                Unavailable due to Fortis wires outage
              </MenuItem>
                     <MenuItem value="Unavailable due to Operational Constraints (EPEA Operating Hour Limits)">
                    Unavailable due to Operational Constraints (EPEA Operating Hour Limits)
                  </MenuItem>

                  </Select>
                </FormControl>
                
                  
              </Grid>
          )}
          
          </Grid>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
        <Button onClick={handleCancel} variant="outlined" sx={{ color: '#e7edf7', borderColor: '#22416b' }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};
